import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'
import PropTypes from 'prop-types'
import {
  Badge
} from 'reactstrap'
import { IoMdClose as CloseIcon } from 'react-icons/io'

import Card from '../Card'

const Container = styled(Card)`
  align-items: center;
  background-color: ${({ theme }) => tinycolor(
    theme.colors.grayContrast
  ).darken(10).toString()};
  display: inline-flex;
  flex-direction: row;
  max-width: 300px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
`

const StyledBadge = styled(Badge)`
  background-color: rgba(0, 0, 0, 0) !important;
  color: ${({ theme }) => tinycolor(
    theme.colors.grayContrast
  ).darken(30).toString()} !important;
  cursor: pointer;
  margin: 6px 0px 6px 12px;
  transition: background-color 0.3s;
  vertical-align: middle;

  &:hover {
    background-color: ${({ theme }) => tinycolor(
      theme.colors.grayContrast
    ).darken(40).toString()} !important;
    color: white !important;
  }
`

export default class CloseableBadge extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onCloseClick: PropTypes.func.isRequired
  }

  render() {
    return (
      <React.Fragment>
        <Container className={ this.props.className }>
          <span>
            { this.props.children }
          </span>
          <StyledBadge onClick={ this.props.onCloseClick }>
            <CloseIcon></CloseIcon>
          </StyledBadge>
        </Container>

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/CloseableBadge/CloseableBadge.js